<!-- Intro Header -->
<header class="sdg-status">
  <div class="intro-body">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-sm-6 title">
              <h4 class="page-heading" i18n>Water-Related Sustainable Development Goals</h4>
              <h2 class="intro-text" i18n>Status - Data</h2>
            </div>
            <div class="col-sm-6">
              <a (click) = "policyBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center " style="margin-bottom: 15px;">
                <span i18n>Resources</span>
              </a>
              <a (click) = "quesBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center " style="margin-bottom: 15px;">
                <span i18n>Questionnaire</span>
              </a>
              <a class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center" style="margin-bottom: 15px; background: #1f487c;">
                <span i18n>Data</span>
              </a>
              <a (click) = "reportBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center" style="margin-bottom: 15px;">
                <span i18n>Reporting</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<div>
  <section class="content-section">
    <table class="table table-striped capacity-table table-bordered" border="0" >
      <thead>
      <tr>
        <th class="rowspan" rowspan="2" i18n> Target </th>
        <th class="rowspan" rowspan="2" i18n> Indicator </th>
        <!-- <th class="rowspan" rowspan="2">National indicator ID</th> -->
        <!-- <th class="rowspan" rowspan="2">National Aspiration-SDG Indicator Value</th> -->
        <!-- <th class="rowspan" rowspan="2">SDG Sub-Indicator For Measurement</th> -->
        <!-- <th class="rowspan" rowspan="2">Unit</th> -->
        <th class="rowspan" rowspan="2" i18n>Measure</th>
        <th class="rowspan" rowspan="2" i18n>Unit</th>
        <th class="rowspan" rowspan="1" colspan="3" i18n>Status</th>
        <!-- <th class="rowspan" rowspan="2">Change between baseline and current year</th> -->
        <!-- <th class="rowspan" rowspan="2">Percentage of 2030 National aspiration achieved in the current year</th> -->
      </tr>
      <tr>
        <th class="blue2" rowspan="1" i18n>Baseline</th>
        <th class="blue2" rowspan="1" i18n>Current</th>
        <th class="blue2" rowspan="1" i18n>Aspiration (2030)</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let r of rows_final;">
        <td *ngIf="r.cspan" [attr.rowspan]="r.cspan" class="{{r.cat_class}}" style="width:330px;text-align:left;">{{r.cat}}</td>
        <td *ngIf="r.scspan" [attr.rowspan]="r.scspan" class="{{r.scat_class}}" style="width:300px;text-align:left;">{{r.scat}}</td>
        <!-- <td *ngIf="r.qcspan" [attr.rowspan]="r.qcspan" class="{{r.scat_class}}">{{r.qcat}}</td> -->
        <!-- <td *ngIf="r.nasivspan" [attr.rowspan]="r.nasivspan" class="{{r.scat_class}}">{{get_percent_text(r.nasiv)}}</td> -->
        <!-- <td *ngIf="r.ssimspan" [attr.rowspan]="r.ssimspan" class="{{r.scat_class}}">{{r.ssim}}</td> -->
        <!-- <td *ngIf="r.unit1span" [attr.rowspan]="r.unit1span" class="{{r.scat_class}}" [innerHTML]="r.unit1"></td> -->
        <td style="text-align:left;" [innerHTML]="r.measure"></td>
        <td [innerHTML]="r.unit2"></td>
        <td>{{r.baseline}}</td>
        <td>{{r.current}}</td>
        <td>{{r.aspiration}}</td>
        <!-- <td *ngIf="r.changespan" [attr.rowspan]="r.changespan">{{get_percent_text(r.change_16_17)}}</td> -->
        <!-- <td *ngIf="r.percentspan" [attr.rowspan]="r.percentspan">{{get_percent_text(r.percent_of_2030)}}</td> -->
      </tr>
      </tbody>
    </table>
  </section>
</div>



// WEBPACK FOOTER //
// ./src/app/sdg/status-data/status-data.component.html